export function ScoreGauge({ value = 0, size = 132, stroke = 10, label = "SCORE" }) {
    const radius = (size - stroke) / 2;
    const circ = 2 * Math.PI * radius;
    const pct = Math.max(0, Math.min(100, value));
    const offset = circ - (pct / 100) * circ;
    const color = pct >= 75 ? "#00E676" : pct >= 50 ? "#00C2FF" : pct >= 30 ? "#FFB000" : "#FF3366";

    return (
        <div className="relative inline-flex items-center justify-center" data-testid="score-gauge">
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#1f1f1f" strokeWidth={stroke} />
                <circle
                    cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color}
                    strokeWidth={stroke} strokeLinecap="round"
                    strokeDasharray={circ} strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.9s ease" }}
                />
            </svg>
            <div className="absolute flex flex-col items-center">
                <span className="font-mono font-bold text-white" style={{ fontSize: size / 3.4 }}>{Math.round(pct)}</span>
                <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-0.5">{label}</span>
            </div>
        </div>
    );
}
